import {
  DATE_TO_NET_FUNCTION,
  TO_TRIMMED_STRING_FUNCTION,
  IS_NOT_NULL_OR_EMPTY_STRING_FUNCTION,
} from './misc'
import { DEBUG_MODE, HOST } from './config'

export const REQUIRE_IP_ADDRESS_TO_LOG_STREAM: boolean = false
export const NO_LOCAL_IP_ADDRESS_PLACEHOLDER: string = 'NONE'
export const NO_IP_ADDRESS_PLACEHOLDER: string = 'UNOBTAINED'

export const INSERT_STREAM_CALLSTRING: string[] = [
  DATE_TO_NET_FUNCTION +
    TO_TRIMMED_STRING_FUNCTION +
    IS_NOT_NULL_OR_EMPTY_STRING_FUNCTION +
    `
self.addEventListener('message', async (event) => {
  if (event.data != undefined && event.data != null && event.data.toString().trim() != '') {
      try {
        if (
          isNotNullOrEmptyString(event?.data?.tokenId) &&
          isNotNullOrEmptyString(event?.data?.contractAddress) &&
          isNotNullOrEmptyString(event?.data?.ipAddress) &&
          isNotNullOrEmptyString(event?.data?.localIPAddress) &&
          isNotNullOrEmptyString(event?.data?.streamStart) &&
          isNotNullOrEmptyString(event?.data?.streamEnd) &&
          isNotNullOrEmptyString(event?.data?.time)
        ) {
          const streamStartDateNet = dateToNetDate(
            isNotNullOrEmptyString(event?.data?.streamStart)
              ? dateToNetDate(toTrimmedString(event?.data?.streamStart))
              : null
          )
          const streamEndDateNet = dateToNetDate(
            isNotNullOrEmptyString(event?.data?.streamEnd)
              ? dateToNetDate(toTrimmedString(event?.data?.streamEnd))
              : null
          )
          const floatTime = isNotNullOrEmptyString(event?.data?.time)
            ? parseFloat(toTrimmedString(event?.data?.time))
            : 0
          const opts = {
            method: 'POST',
            body: JSON.stringify({
              address: toTrimmedString(event?.data?.walletAddress),
              tokenId: toTrimmedString(event?.data?.tokenId),
              contractAddress: toTrimmedString(event?.data?.contractAddress),
              streamStart: event?.data?.streamStart,
              streamEnd: event?.data?.streamEnd,
              ipAddress: toTrimmedString(event?.data?.ipAddress),
              localIPAddress: toTrimmedString(event?.data?.localIPAddress),
              time: event?.data?.time,
              web2UserId: toTrimmedString(event?.data?.web2UserId),
              bz: event?.data?.bz,
              cs: false,
              ps: true,
            }),
          }
          await fetch('${HOST}' + '/api/p.stream-sv/st/is', opts)
            .then(async (resp) => {
              const respon = await resp.json()
              if (${DEBUG_MODE}) console.log(respon?.success ? respon?.success : false)
              self.postMessage({
                success: respon?.success ? respon?.success : false,
                isitomlao: respon?.isitomlao == true ? true : false
              })
            })
            .catch((er) => {
              if (${DEBUG_MODE}) console.log(er)
              self.postMessage({
                success: false, 
                isitomlao: false,
              })
            })
        } else self.postMessage({
          success: false, 
          isitomlao: false,
        })
      } catch (e) {
        if (${DEBUG_MODE}) console.log(e)
        self.postMessage({
          success: false, 
          isitomlao: false,
        })
      }
    } else 
      self.postMessage({
        success: false, 
        isitomlao: false,
    })
  })
`,
]
